module.exports = __webpack_public_path__ + "img/motor_no16.adff8192.jpg";